import { 
	Box, 
	Stack, 
	Link, 
	Button, 
	Image, 
	IconButton, 
	Icon, 
	useBreakpointValue,
} from '@chakra-ui/react'
import GovbrLogo from 'modules/common/assets/images/govbr-logo.svg'
import { IoMdContrast } from 'react-icons/io'
import { FullPageLayout, DrawerMenu } from '..'

export const Govbar = () => {
	return (
		<FullPageLayout boxShadow='xs'>
			<Box py={10} display='flex' justifyContent='space-between'>
				<Image src={GovbrLogo} alt='logotipo do governo brasileiro' />

				<NavigationMenu />
			</Box>
		</FullPageLayout>
	)
}

const NavigationMenu = () => {
	const mobileScreen = useBreakpointValue({ base: true, lg: false })

	if (mobileScreen) {
		return (
			<DrawerMenu placement='right'>
				<MenuButtons direction="column" />
			</DrawerMenu>
		)
	}

	return (
		<MenuButtons direction="row" />
	)
}

const MenuButtons = ({ direction }) => {
	return (
		<Stack direction={direction} alignItems='center' spacing={2.5}>
			<Link 
				href='https://www.gov.br/pt-br/orgaos-do-governo'
				isExternal 
				color='blue.300' 
				fontWeight='medium'
				_hover={{ textDecoration: 'none' }}
			>
				Órgaõs do Governo
			</Link>
			<Link 
				href='https://www.gov.br/acessoainformacao/pt-br'
				isExternal 
				color='blue.300' 
				fontWeight='medium'
				_hover={{ textDecoration: 'none' }}
			>
				Acesso à Informação
			</Link>
			<Link 
				href='http://www4.planalto.gov.br/legislacao/'
				isExternal 
				color='blue.300' 
				fontWeight='medium'
				_hover={{ textDecoration: 'none' }}
			>
				Legislação
			</Link>
			<Link 
				href='https://www.gov.br/governodigital/pt-br/acessibilidade-digital'
				isExternal 
				color='blue.300' 
				fontWeight='medium'
				_hover={{ textDecoration: 'none' }}
			>
				Acessibilidade
			</Link>

			<IconButton 
				variant='ghost' 
				_hover={{ bg: 'none' }} 
				icon={<Icon as={IoMdContrast} />} 
				color='blue.300' 
				cursor='pointer'
				aria-label='Liga e desliga alto contraste'
			/>

			<Button 
				bg='blue.300' 
				color='white' 
				borderRadius='3xl' 
				fontWeight='medium'
				_hover={{ bg: 'blue.300', color: 'white' }}
			>
				Entrar
			</Button>
		</Stack>
	)
}